import { Container, Row, Col, Badge, Button } from 'react-bootstrap';
import { motion } from 'motion/react';
import brandData from '../../data/brandData.json';

const Pakages = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  return (
    <section id="brand-packages" className="section-lg bg-soft-primary overflow-hidden">
      <Container>
        <Row className="mb-5">
          <Col xs={12} className="text-center">
            <motion.h2 className="text-primary fw-semibold mb-0"
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            >
              Pick the scope that fits
            </motion.h2>
          </Col>
        </Row>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Row className="g-4 align-items-stretch">
            {brandData.packages.map((pkg) => (
              <Col lg={4} md={6} key={pkg.id}>
                <motion.div className={pkg.cardClass}
                  variants={cardVariants} whileHover={{ y: -10, scale: pkg.featured ? 1.03 : 1.02, transition: { duration: 0.3 } }}
                >
                  <div className={pkg.featured ? 'px-4 pt-4 pb-2 border-bottom border-light-subtle' : 'px-4 pt-4 pb-2 border-bottom'}>
                    <div className="d-flex align-items-center">
                      <Badge bg="" className={`bg-${pkg.badge.variant} me-2`}>
                        <i className={`${pkg.badge.icon} me-1`}></i>
                        {pkg.badge.text}
                      </Badge>
                      <h5 className={pkg.featured ? 'mb-0 text-white' : 'mb-0'}>{pkg.title}</h5>
                    </div>
                    <small className={pkg.featured ? 'text-white-50' : 'text-secondary'}>{pkg.subtitle}</small>
                  </div>
                  <div className="p-4">
                    <ul className="list-unstyled mb-4 small lh-lg">
                      {pkg.features.map((feature, index) => (
                        <motion.li className="d-flex"
                          key={index}
                          initial={{ opacity: 0, x: -10 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          viewport={{ once: true }}
                          transition={{ delay: index * 0.1 + 0.3 }}
                        >
                          <i className={`${feature.icon} ${feature.color || (pkg.featured ? 'text-white' : '')} me-2`}></i> {feature.text}
                        </motion.li>
                      ))}
                    </ul>
                    <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
                      <Button href="#contact-brand" variant={pkg.buttonVariant} className="w-100">
                        {pkg.buttonText}
                      </Button>
                    </motion.div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  )
}

export default Pakages;
